export default __webpack_public_path__ + "static/media/c11.8b2764e3.png";